import { render } from "./TourInnerPoints.vue?vue&type=template&id=b205f67c&scoped=true"
import script from "./TourInnerPoints.vue?vue&type=script&lang=js"
export * from "./TourInnerPoints.vue?vue&type=script&lang=js"

import "./TourInnerPoints.vue?vue&type=style&index=0&id=b205f67c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b205f67c"]])

export default __exports__